export const VIRTUALIZED_TABLE_COLUMNS_SET = 'VIRTUALIZED_TABLE_COLUMNS_SET';
export const VIRTUALIZED_TABLE_COLUMN_WIDTH_OFFSET_SET =
    'VIRTUALIZED_TABLE_COLUMN_WIDTH_OFFSET_SET';
export const VIRTUALIZED_TABLE_COLUMN_WIDTH_SET =
    'VIRTUALIZED_TABLE_COLUMN_WIDTH_SET';

export const VIRTUALIZED_TABLE_ITEMS_SET = 'VIRTUALIZED_TABLE_ITEMS_SET';
export const VIRTUALIZED_TABLE_ITEM_SET = 'VIRTUALIZED_TABLE_ITEM_SET';

export const VIRTUALIZED_TABLE_ITEM_VALUE_SET =
    'VIRTUALIZED_TABLE_ITEM_VALUE_SET';
export const VIRTUALIZED_TABLE_ITEMS_VALUE_SET =
    'VIRTUALIZED_TABLE_ITEMS_VALUE_SET';

export const VIRTUALIZED_TABLE_ITEMS_DELETE = 'VIRTUALIZED_TABLE_ITEMS_DELETE';

export const VIRTUALIZED_TABLE_ERRORS_SET = 'VIRTUALIZED_TABLE_ERRORS_SET';
export const VIRTUALIZED_TABLE_ERROR_SET = 'VIRTUALIZED_TABLE_ERROR_SET';
export const VIRTUALIZED_TABLE_ERROR_REMOVE = 'VIRTUALIZED_TABLE_ERROR_REMOVE';

export const VIRTUALIZED_TABLE_RESET = 'VIRTUALIZED_TABLE_RESET';

export const VIRTUALIZED_TABLE_SUBMIT_HAS_FAILED =
    'VIRTUALIZED_TABLE_SUBMIT_HAS_FAILED';

export const VIRTUALIZED_TABLE_COLUMN_MIN_WIDTH = 80;
